// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"048160b7","453":"46aa4b06","455":"95934941"}[chunkId] + ".chunk.js";
};